export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 rounded-3xl bg-background-50 p-8 md:p-12">
          {/* Text Side */}
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
              <i className="ri-smartphone-line"></i>
              <span className="whitespace-nowrap">移动阅读</span>
            </div>
            <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
              随时随地 · 追漫利器
            </h3>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              九妖漫画网移动端完美适配手机与平板设备，下拉式阅读体验丝滑流畅。收藏喜欢的漫画，追更提醒不错过任何一话更新，地铁、午休、睡前，想读就读。
            </p>
            <div className="flex flex-wrap items-center gap-3 mt-5 justify-center lg:justify-start">
              <span className="px-4 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors">
                <i className="ri-download-line mr-1"></i>iOS 版
              </span>
              <span className="px-4 py-2 bg-background-200 text-foreground-700 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer hover:bg-background-300 transition-colors">
                <i className="ri-android-line mr-1"></i>Android 版
              </span>
              <span className="px-4 py-2 border border-background-300 text-foreground-600 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer hover:border-primary-400 hover:text-primary-600 transition-colors">
                <i className="ri-global-line mr-1"></i>网页版
              </span>
            </div>
          </div>

          {/* Visual Side */}
          <div className="flex-shrink-0 w-full max-w-xs lg:max-w-sm">
            <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-[3/4]">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20a%20smartphone%20displaying%20colorful%20manga%20comic%20pages%20with%20Japanese%20manga%20aesthetic%2C%20warm%20cream%20background%2C%20soft%20coral%20and%20amber%20accents%2C%20modern%20minimal%20UI%20design%2C%20reading%20app%20interface%20mockup%2C%20clean%20composition%2C%20friendly%20and%20inviting%20atmosphere%2C%20high%20detail%20digital%20art&width=900&height=1200&seq=app-section-2026&orientation=portrait"
                alt="九妖漫画网移动端阅读体验展示"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}